import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingMode } from '../Components/LoadingMode';

import cxImage from '../Assets/Image/cx-money.png';
import { IoIosArrowBack } from 'react-icons/io';

export default function News() {
  const params = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState('');
  const [news, setNews] = useState({});

  const { newsId } = params;

  useEffect(() => {
    if (newsId === '0') {
      setNews({
        title: 'We are a FX Trading social Platform trusted by many client',
        images: [
          {
            image: cxImage,
          },
        ],
        body: 'Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. \n Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.Peer-to-peer (P2P) exchanges allow sellers the freedom to define how they want to be paid. Buy and sell crypto with over 700 payment methods, including bank transfer, cash, M-Pesa, and multiple e-wallets.',
      });
    }

    async function getNews() {
      if (newsId === '0') return;
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/fx-news/${newsId}/single`
        );
        setNews(response?.data);
      } catch (error) {
        console.log(error);
        setIsError(error.message);
      } finally {
        setIsLoading(false);
      }
    }
    getNews();
  }, [newsId]);

  return (
    <section className='px-4 sm:px-10 md:px-20 max-w-[1440px] mx-auto mt-8 md:mt-24 font-pin'>
      <button
        className='text-b-mc font-semibold flex items-center gap-2 mb-6'
        onClick={() => navigate('/fXnews')}
      >
        <IoIosArrowBack />
        Go Back
      </button>
      {isLoading ? (
        <div>
          <LoadingMode />
        </div>
      ) : !!isError ? (
        <h4 className='font-medium text-[1.2rem]'>News does not exist</h4>
      ) : (
        <figure className='w-full md:w-[40rem] flex flex-col gap-[1rem] mx-auto overflow-hidden'>
          <h4 className='capitalize font-semibold text-[2rem] mb-[0.4rem] leading-[2.5rem] '>
            {news.title}
          </h4>
          <div className='w-full h-[22.7rem]'>
            <img
              src={
                newsId === '0'
                  ? news?.images?.[0]?.image
                  : `https://apex.loyaltyview.com/storage/${news?.images?.[0]?.image}`
              }
              alt={`img-of-${news.title}`}
              className='w-full h-full object-cover'
            />
          </div>

          <figcaption className='pb-1'>
            <p className='text-[1rem] font-normal text-[#2C2F30]'>
              {news.body?.split('\n').map((item, idx) => (
                <span key={idx} className='block pb-3'>
                  {item}
                </span>
              ))}
            </p>
          </figcaption>
        </figure>
      )}
    </section>
  );
}
